module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-bfc4c67ac1669f57d883a58964145a17.png";